import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  getUserDetailsFromUserId,
  getUserDetailsDateRange,
  getUserDetailsByType,
} from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
//import { SuperAdminTopTextSearchIcon } from "../../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
import { SuperAdminTopTextSearchIcon } from "./SuperAdminUserFilter";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import EventsPageComponent from "../insidePageComponent/EventsPageComponent";
import FavoritesPageComponent from "../insidePageComponent/FavoritesPageComponent";
import MiscPageComponent from "../insidePageComponent/MiscPageComponent";
import NominationPageComponent from "../insidePageComponent/NominationPageComponent";
import OrderingPageComponent from "../insidePageComponent/OrderingPageComponent";
import ReviewsPageComponent from "../insidePageComponent/ReviewsPageComponent";
import SeatingPageComponent from "../insidePageComponent/SeatingPageComponent";
import WalletScanPayPageComponent from "../insidePageComponent/WalletScanPayPageComponent";
import SuperAdminReusableTopView from "./SuperAdminReusableTopView";
import moment from "moment";
import MiscellaneousPageComponent from "../insidePageComponent/MiscellaneousPageComponent";
import { UserTicketsPageComponent } from "../insidePageComponent/UserTicketsPageComponent";
import { LiveStreamingPageComponent } from "../insidePageComponent/LiveStreamingPageComponent";
import VideoContentPageComponent from "../insidePageComponent/VideoContentPageComponent";
import { OffersPageComponent } from "../insidePageComponent/OffersPageComponent";
import { useDispatch, useSelector } from "react-redux";
import isEmpty from "../../../../../store/validation/is-Empty";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import { Form, Image, Table } from "react-bootstrap";
import UserStats from "./SuperAdminUserStats";
import UserFilters from "./SuperAdminUserFunc";
import UserSort from "./SuperAdminUserSort";
import { ReelsPageComponent } from "../insidePageComponent/ReelsPageComponent";


const SuperAdminAllUsersView = ({ pageChangeButtonHandler }) => {
  const { userId } = useParams();
  const history = useHistory();

  //states
  const [loading, setLoading] = useState(false);
  // const [showFilter, seShowFilter] = useState(false);
  const [selectedTab, setSelectedTab] = useState("1");
  const dispatch = useDispatch();
  const [favPage, setFavPage] = useState("1");
  const userData = useSelector((state) => {
    return !isEmpty(state.userManagement?.allUserList)
      ? state.userManagement?.allUserList?.filter(
        (e) => e._id.toString() === userId
      )[0]
      : {};
  });

  if (isEmpty(userData)) {
    history.push("/superadminallusers", { back: true });
  }

  const dateRange = useSelector((state) => {
    return !isEmpty(state.userManagement?.dateRange)
      ? state.userManagement?.dateRange
      : {};
  });

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const seatingData = useSelector((state) => {
    
    return !isEmpty(state.userManagement?.userSeating)
      ? state.userManagement?.userSeating?.data
      : [];
      
  });
  const reelsData = useSelector((state) => {
    
    return !isEmpty(state.userManagement?.userReels)
      ? state.userManagement?.userReels
      : [];
      
  });


  const orderingData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userOrdering)
      ? state.userManagement?.userOrdering
      : [];
  });
 
  const eventsData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userEvents)
      ? state.userManagement?.userEvents
      : [];
  });

  const walletData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userWallet)
      ? state.userManagement?.userWallet
      : [];
  });

  const nominationData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userNominations)
      ? state.userManagement?.userNominations
      : [];
  });

  const favData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userFavourites)
      ? state.userManagement?.userFavourites
      : [];
  });

  const reviewData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userReviews)
      ? state.userManagement?.userReviews
      : [];
  });

  const refferalData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userReferral)
      ? state.userManagement?.userReferral
      : [];
  });

  const miscData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userMiscellaneous)
      ? state.userManagement?.userMiscellaneous
      : [];
  });

  const ticketsData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userTickets)
      ? state.userManagement?.userTickets
      : [];
  });

  const liveData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userLiveStreaming)
      ? state.userManagement?.userLiveStreaming
      : [];
  });

  const videoData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userVideoContent)
      ? state.userManagement?.userVideoContent
      : [];
  });

  const offersData = useSelector((state) => {
    return !isEmpty(state.userManagement?.userOffers)
      ? state.userManagement?.userOffers
      : [];
  });

  const expData = useSelector((state) => {
    return !isEmpty(state.userManagement?.Userexperiences)
      ? state.userManagement?.Userexperiences
      : [];
  });
 

  // const reelsData = useSelector((state) => {  
  // return isEmpty(state.userManagement?.userVideoContent)
  // ? state.userManagement?.userVideoContent
  // : [];  
  //  });
  //  console.log(reelsData)

  useEffect(() => {
    if (!isEmpty(seatingData)) {
      let walkData = [];
      let reservationData = [];
      let waitListData = [];
      for (let i = 0; i < seatingData.length; i++) {
        if (seatingData[i].service_type === "RESERVATION") {
          reservationData.push(seatingData[i]);
        } else if (
          seatingData[i].service_type === "SEATING" &&
          seatingData[i].isWalkIn === true
        ) {
          walkData.push(seatingData[i]);
        } else if (
          seatingData[i].service_type === "SEATING" &&
          seatingData[i].isWalkIn === false
        ) {
          waitListData.push(seatingData[i]);
        }
      }
      setStatData({
        total: seatingData.length || 0,
        reservations: reservationData.length,
        walkIn: walkData.length,
        waitList: waitListData.length,
      });
    }
  }, [seatingData]);

  useEffect(() => {
    if(!isEmpty(reelsData)){
      setStatData(reelsData.stats);
    }
  }, [reelsData]);

  useEffect(() => {
    if (!isEmpty(nominationData)) {
      setStatData({ total: nominationData.stats.count });
    }
  }, [nominationData]);

  useEffect(() => {
    if (!isEmpty(orderingData)) {
      setStatData(orderingData.stats);
    }
  }, [orderingData]);


  useEffect(() => {
    if (!isEmpty(eventsData)) {
      setStatData(eventsData.stats);
    }
  }, [eventsData]);

  useEffect(() => {
    if (!isEmpty(walletData)) {
      setStatData(walletData.stats);
    }
  }, [walletData]);

  useEffect(() => {
    if (!isEmpty(nominationData)) {
      setStatData(nominationData.stats);
    }
  }, [nominationData]);

  useEffect(() => {
    if (!isEmpty(favData)) {
      setStatData(favData.stats);
    }
  }, [favData]);

  useEffect(() => {
    if (!isEmpty(reviewData)) {
      setStatData(reviewData.stats);
    }
  }, [reviewData]);

  useEffect(() => {
    if (!isEmpty(refferalData)) {
      setStatData(refferalData.stats);
    }
  }, [refferalData]);

  useEffect(() => {
    if (!isEmpty(offersData)) {
      setStatData(offersData.stats);
    }
  }, [offersData]);

  useEffect(() => {
    if (!isEmpty(videoData)) {
      setStatData(videoData.stats);
    }
  }, [videoData]);

  useEffect(() => {
    if (!isEmpty(liveData)) {
      setStatData(liveData.stats);
    }
  }, [liveData]);

  useEffect(() => {
    if (!isEmpty(miscData)) {
      setStatData(miscData.stats);
    }
  }, [miscData]);

  useEffect(() => {
    if (!isEmpty(ticketsData)) {
      setStatData(ticketsData.stats);
    }
  }, [ticketsData]);

  // useEffect(() => {
  //   if(!isEmpty(reelsData)){
  //     let totalReelsWatched=[];
  //     let reelsSkiped=[];
  //     let reelsTapped=[];
  //     let orderedBooked=[];
  //     for( let i = 0; i < reelsData.length; i++){

  //     }
  //     setStatData({
  //       totalReelsWatched:
  //       reelsSkiped:
  //       reelsTapped:
  //       orderedBooked:
  //     })
  //   }
  // },[])

  // const [state, setState] = useState({
  //   code: "",
  //   SortBy: "",
  //   Location: "",
  //   Status: "", 
  // });

  // const handleChangeCode = (event) => {
  //   setState({
  //     ...state, 
  //     [event.target.name]: event.target.value,
  //   });
  // };

  // const handleShowFilter = () => {
  //   seShowFilter({
  //     showFilter: !showFilter.showFilter,
  //   });
  // };
  // const handleCloseFilter = () => seShowFilter(false);

  //filter for seating starts ///
  const [showsearch, setShowSearch] = useState(false);

  const [sortByDay, setSortByDay] = useState(4);
  const [startDay, setStartDay] = useState("");
  const [endDay, setEndDay] = useState("");

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setSort = (data) => () => {
    setSortBy(data);
    setAnchorEl(null);
  };

  const [sortBy, setSortBy] = useState("");

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [clickedSearch, setClickedSearch] = useState(false);

  const [selectedrequestType, setSelectedrequestType] = useState("ALL");
  const [searchSelectedRequestType, setSearchSelectedRequest] = useState("ALL");
  const [selectedSeatingStatus, setSelectedSeatingStatus] = useState("ALL");
  const [searchSelectedSeatingStatus, setSearchSelectedSeatingStatus] =
    useState("ALL");
  const [pax, setPax] = useState();
  const [paxSearch, setPaxSearch] = useState();
  const [sortByDate, changeSortByDate] = useState(1);

  const [orderFilter, setOrderFilter] = useState({
    order_type: 10,
    order_status: 10,
  });

  const [eventFilter, setEventFilter] = useState({});

  const [scanAndPayFilter, setScanANdPayFilter] = useState({
    payment_status: "All",
  });

  const [nominationsFilter, setNominationsFilter] = useState({
    city: "",
  });

  const [favouriteFilter, setFavouriteFilter] = useState({
    city: "",
  });

  const onDateChangeHandler = () => (data, type, selected) => {
    dispatch(getUserDetailsDateRange({ ...data, selected: selected }));
  };

  const [search, setSearch] = useState("");

  const onChangeOrderState = (key, value) => {
    //setClickedSearch(false);
    console.log(key, value);
    let existingData = JSON.parse(JSON.stringify(orderFilter));
    existingData[key] = value;
    setOrderFilter(existingData);
  };

  const onClickSearch = () => {
    setSearchSelectedRequest(selectedrequestType);
    setSearchSelectedSeatingStatus(selectedSeatingStatus);
    setPaxSearch(parseInt(pax));
    setClickedSearch(true);
  };

  const [statData, setStatData] = useState([]);

  const handleTab = (e) => {
    setSearch("");
    setSelectedTab(e);
  };

  const [showFilter, setShowFilter] = useState(false);
  const [filterBy, setFilterBy] = useState("");

  const onFilterCancel = () => {
    setShowFilter(false);
    setFilterBy("");
  };

  const onFilterSearch = (data) => {
    setFilterBy(data);
  };

  const getData = () => {
    if (selectedTab === "1") {
      let query = {
        type: "SEATING",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "2") {
      let query = {
        type: "ORDERING",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "3") {
      let query = {
        type: "EXPERIENCE",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "4") {
      let query = {
        type: "WALLET",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "5") {
      let query = {
        type: "NOMINATIONS",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "6") {
      let query = {
        type: "FAVOURITES",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "7") {
      let query = {
        type: "REVIEWS",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "8") {
      let query = {
        type: "REFERRAL",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "9") {
      let query = {
        type: "MISCELLANEOUS",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "10") {
      let query = {
        type: "USER_TICKETS",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "11") {
      let query = {
        type: "LIVE_STREAMING",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "12") {
      let query = {
        type: "VIDEO_CONTENT",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } else if (selectedTab === "13") {
      let query = {
        type: "OFFERS",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } 
    else if (selectedTab === "14") {
      let query = {
        type: "SHORT_VIDEOS",
        startDate: dateRange.startDate,
        endDate: dateRange?.endDate,
      };
      console.log("14Tab",query)
      dispatch(
        getUserDetailsByType(userId, auth.accessToken, query, onSuccess)
      );
    } 
  };

  useEffect(() => {
    if (!isEmpty(dateRange)) {
      getData();
    }
  }, [dateRange.selected, selectedTab]);

  const onSuccess = () => {
  };
  return (
    <>
      {!loading ? (
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation
                backState={true}
                backIcon={false}
                link="/superadminallusers"
                displayText="Back"
              />
              <div className="super-admin-inside-right-side-panel">
                <SuperAdminReusableTopView data={userData} />
                <div className="row">
                  <div className="col-4">
                    <div className="d-flex align-items-center">
                      <Image
                        onClick={() => setShowSearch(!showsearch)}
                        alt="search"
                        title="search"
                        width="80px"
                        src={require("../../../../../assets/images/iconButton/newsearchicon.svg")}
                      />
                      <UserSort
                        selectedTab={selectedTab}
                        anchorEl={anchorEl}
                        setSort={setSort}
                        handleClose={handleClose}
                      />
                      <div
                        className="f10-400"
                        align="center"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                      >
                        <img
                          src={require("../../../../../assets/images/iconButton/sortbtn.svg")}
                          width="80px"
                        />
                      </div>
                      <div
                        className="f10-400"
                        align="center"
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        <img
                          src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
                          width="80px"
                        />
                      </div>
                      <div className="f10-400" align="center">
                        <img
                          src={require("../../../../../assets/images/iconButton/downloadbtn.svg")}
                          width="80px"
                          alt="icon"
                          title="Download"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-4"></div>
                  <div
                    className="col-4"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <div className="mr-3">
                      <SelectFilter
                        onDateChange={onDateChangeHandler()}
                        defaultSelected="LAST30DAYS"
                      />
                    </div>
                  </div>
                </div>
                {showsearch && (
                  <>
                    <div className="col-4">
                      <Form.Control
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="amSearch"
                      />
                    </div>
                  </>
                )}
                <UserFilters
                  showFilter={showFilter}
                  selectedTab={selectedTab}
                  onCancel={onFilterCancel}
                  onSearch={onFilterSearch}
                  innerTab={"Tes"}
                  filterData={"Tes"}
                  favPage={favPage}
                />
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <UserStats selectedTab={selectedTab} statData={statData} />
                </div>
                <div className="enTabs d-flex  align-items-center mt-4 mb-2 hidescrollbar"
                  style={{ width: "100%", overflowX: "scroll", maxWidth: "100%" }}>
                  <Button
                    onClick={() => handleTab("1")}
                    className={`${selectedTab === "1" ? "active" : ""}`}
                  >
                    Seating
                  </Button>
                  <Button
                    onClick={() => handleTab("2")}
                    className={`${selectedTab === "2" ? "active" : ""}`}
                  >
                    Ordering
                  </Button>
                  <Button
                    onClick={() => handleTab("3")}
                    className={`${selectedTab === "3" ? "active" : ""}`}
                  >
                    Experience
                  </Button>
                  <Button
                    onClick={() => handleTab("4")}
                    className={`${selectedTab === "4" ? "active" : ""}`}
                  >
                    Wallet  Scan &amp; Pay
                  </Button>
                  <Button
                    onClick={() => handleTab("5")}
                    className={`${selectedTab === "5" ? "active" : ""}`}
                  >
                    Nominations
                  </Button>
                  <Button
                    onClick={() => handleTab("6")}
                    className={`${selectedTab === "6" ? "active" : ""}`}
                  >
                    Favourites
                  </Button>
                  <Button
                    onClick={() => handleTab("7")}
                    className={`${selectedTab === "7" ? "active" : ""}`}
                  >
                    Reviews
                  </Button>
                  <Button
                    onClick={() => handleTab("8")}
                    className={`${selectedTab === "8" ? "active" : ""}`}
                  >
                    Referral
                  </Button>
                  <Button
                    onClick={() => handleTab("9")}
                    className={`${selectedTab === "9" ? "active" : ""}`}
                  >
                    Miscellaneous
                  </Button>
                  <Button
                    onClick={() => handleTab("10")}
                    className={`${selectedTab === "10" ? "active" : ""}`}
                  >
                    User Tickets
                  </Button>
                  <Button
                    onClick={() => handleTab("11")}
                    className={`${selectedTab === "11" ? "active" : ""}`}
                  >
                    Live Streaming
                  </Button>
                  <Button
                    onClick={() => handleTab("12")}
                    className={`${selectedTab === "12" ? "active" : ""}`}
                  >
                    Video Content
                  </Button>
                  <Button
                    onClick={() => handleTab("13")}
                    className={`${selectedTab === "13" ? "active" : ""}`}
                  >
                    Offers
                  </Button>
                  <Button
                    onClick={() => handleTab("14")}
                    className={`${selectedTab === "14" ? "active" : ""}`}
                  >
                    Reels
                  </Button>
                </div>
                {selectedTab === "1" && (
                  <SeatingPageComponent
                    data={seatingData}
                    search={search}
                    sortBy={sortBy}
                    filterBy={filterBy}
                    getData={getData}
                  />
                )}
                {selectedTab === "2" && (
                  <OrderingPageComponent
                    data={orderingData?.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    orderFilter={orderFilter}
                    startDate={startDate}
                    endDate={endDate}
                    onChangeOrderState={onChangeOrderState}
                    onClickSearch={onClickSearch}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "3" && (
                  <EventsPageComponent
                    data={expData?.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    eventFilter={eventFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "4" && (
                  <WalletScanPayPageComponent
                    data={walletData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    scanAndPayFilter={scanAndPayFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "5" && (
                  <NominationPageComponent
                    data={nominationData.data || []}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    nominationsFilter={nominationsFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "6" && (
                  <FavoritesPageComponent
                    pageChanger={pageChangeButtonHandler}
                    data={favData.data || []}
                    // setInsidePageFav={(e) => setFavPage(e)}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                  />
                )}
                {selectedTab === "7" && (
                  <ReviewsPageComponent
                    data={reviewData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "8" && (
                  <MiscPageComponent
                    data={refferalData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "9" && (
                  <MiscellaneousPageComponent
                    data={miscData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "10" && (
                  <UserTicketsPageComponent
                    data={ticketsData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "11" && (
                  <LiveStreamingPageComponent
                    data={liveData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "12" && (
                  <VideoContentPageComponent
                    data={videoData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {selectedTab === "13" && (
                  <OffersPageComponent
                    data={offersData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )} 
                {selectedTab === "14" && (
                  <ReelsPageComponent
                    data={reelsData.data || []}
                    pageChanger={pageChangeButtonHandler}
                    clickedSearch={clickedSearch}
                    sortByDate={sortByDate}
                    search={search}
                    startDay={startDay}
                    endDay={endDay}
                    sortByDay={sortByDay}
                    favouriteFilter={favouriteFilter}
                    startDate={startDate}
                    endDate={endDate}
                    sortBy={sortBy}
                    filterBy={filterBy}
                  />
                )}
                {/* <BasicPagination
                  totalRecords={5}
                  limit={10}
                  batch={1}
                  // onBatchChange={(e) => handleBatchChange(e)}
                /> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <AmealioLoader />
      )}
    </>
  );
};

SuperAdminAllUsersView.propTypes = {
  auth: PropTypes.object.isRequired,
  getUserDetailsFromUserId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  userAllData: state.userManagement.userAllData,
});

export default connect(mapStateToProps, {
  getUserDetailsFromUserId,
})(SuperAdminAllUsersView);
